import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer-tos',
  templateUrl: './footer-tos.component.html',
  styleUrls: ['./footer-tos.component.scss'],
})
export class FooterTOSComponent implements OnInit {
  displayForCeremony = environment.tenant === 'ceremony';
  displayForJoin = environment.tenant === 'join';

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}
}
